import Handler from "./Handler";

// Campaigns (Phase 8, admin backend /admin/campaigns). Every call returns { ok, data, message } like the
// notification console helpers, so a page never looks inside the response envelope.
const BASE = "/admin/campaigns";

const wrap = (response) => {
    if (response?.success) return { ok: true, data: response?.data?.data || {}, message: response?.data?.message || "" };
    return { ok: false, data: response?.data?.data || null, message: response?.data?.message || "Could not do that. Try again." };
};
const call = async (config) => wrap(await Handler({ ...config, silent: true }));

export const listCampaigns = (params) => call({ method: "get", url: BASE, params });
export const getCampaign = (campaignId) => call({ method: "get", url: `${BASE}/${campaignId}` });
export const createCampaign = (payload) => call({ method: "post", url: BASE, data: payload });
export const updateCampaign = (campaignId, payload) => call({ method: "put", url: `${BASE}/${campaignId}`, data: payload });
export const setCampaignStatus = (campaignId, to, note) => call({ method: "post", url: `${BASE}/${campaignId}/status`, data: { to, ...(note ? { note } : {}) } });
export const duplicateCampaign = (campaignId) => call({ method: "post", url: `${BASE}/${campaignId}/duplicate` });
export const fetchOverlap = (campaignId) => call({ method: "get", url: `${BASE}/${campaignId}/overlap` });
export const fetchRuns = (campaignId) => call({ method: "get", url: `${BASE}/${campaignId}/runs` });
export const fetchRunProgress = (runId) => call({ method: "get", url: `${BASE}/runs/${runId}` });
export const retryFailedRun = (runId) => call({ method: "post", url: `${BASE}/runs/${runId}/retry-failed` });

export const fetchAudienceOptions = () => call({ method: "get", url: `${BASE}/audience/options` });
export const countAudience = (payload) => call({ method: "post", url: `${BASE}/audience/count`, data: payload });
export const reachAudience = (payload) => call({ method: "post", url: `${BASE}/audience/reach`, data: payload });
export const uploadList = (payload) => call({ method: "post", url: `${BASE}/uploads`, data: payload });
export const fetchUpload = (uploadId) => call({ method: "get", url: `${BASE}/uploads/${uploadId}` });
export const fetchCouponOptions = () => call({ method: "get", url: `${BASE}/coupons/options` });

export const fetchMessages = (campaignId) => call({ method: "get", url: `${BASE}/${campaignId}/messages` });
// One message is opened, saved and tested in the shared template editor (notificationConsoleApi: openEditor ...).

export const fetchCampaignReport = (campaignId) => call({ method: "get", url: `${BASE}/${campaignId}/report` });
export const fetchRunReport = (runId) => call({ method: "get", url: `${BASE}/runs/${runId}/report` });
export const exportRun = (runId) => call({ method: "get", url: `${BASE}/runs/${runId}/export` });

// The languages list lives in the notification console (Phase 6.6).
export const fetchLanguageList = () => call({ method: "get", url: "/admin/notification-console/languages" });
